import {
  ActivityIcon,
  AdminIcon,
  AssetMappingIcon,
  AssetsIcon,
  BackIcon,
  BellIcon,
  ChartIcon,
  ConfigIcon,
  DeviceIcon,
  EFAddIcon,
  EFAppearanceIcon,
  EFArrowSyncIcon,
  EFCanlendar,
  EFCheckBlankIcon,
  EFCheckMark,
  EFCopyIcon,
  EFDeleteIcon,
  EFDownloadIcon,
  EFDragIndicatorIcon,
  EFDuplicateIcon,
  EFEmptyIcon,
  EFFilterIcon,
  EFLogoutIcon,
  EFPencilIcon,
  EFPendingIcon,
  EFReplyIcon,
  EFTableSettingIcon,
  EFUploadImage,
  ForwardIcon,
  GroupIcon,
  HelpIcon,
  HomeIcon,
  MoreIcon,
  ReportIcon,
  SearchIcon,
  SettingIcon,
  SunIcon
} from '~/components/EFIcons'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import FirstPageIcon from '@mui/icons-material/FirstPage'
import LastPageIcon from '@mui/icons-material/LastPage'
import DownloadIcon from '@mui/icons-material/Download'
import CircleIcon from '@mui/icons-material/Circle'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined'
import CloseIcon from '@mui/icons-material/Close'
import LanguageIcon from '@mui/icons-material/Language'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import FullscreenIcon from '@mui/icons-material/Fullscreen'
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit'
import ErrorIcon from '@mui/icons-material/Error'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import DoDisturbIcon from '@mui/icons-material/DoDisturb'
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle'
import ContrastIcon from '@mui/icons-material/Contrast'
import CancelIcon from '@mui/icons-material/Cancel'
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined'
import PanoramaFishEyeIcon from '@mui/icons-material/PanoramaFishEye'

const icoSize = 40

export function IconTestPage() {
  return (
    <div className='testGridWrapper'>
      <h2>List of icons used in EnableFleet manager and where they are used</h2>
      <p>https://mui.com/material-ui/material-icons/</p>
      <br />
      <h3>Arrows</h3>
      <div className='testGrid'>
        <div>
          <EFArrowSyncIcon />
          <p>
            <strong>EFArrowSyncIcon.</strong> Refresh page navigation button
          </p>
        </div>
        <div>
          <BackIcon />
          <p>
            <strong>EFBackIcon.</strong> Nav drawer expansion
          </p>
        </div>
        <div>
          <ForwardIcon />
          <p>
            <strong>EFForwardIcon.</strong> Nav drawer contraction
          </p>
        </div>
        <div>
          <KeyboardArrowDownIcon />
          <p>
            <strong>KeyboardArrowDownIcon.</strong> network, form dropdown, customisation
            profile, configuration history
          </p>
        </div>
        <div>
          <ExpandMoreIcon />
          <p>
            <strong>ExpandMoreIcon.</strong> fleet permission tree expand up
          </p>
        </div>
        <div>
          <KeyboardArrowDownOutlinedIcon />
          <p>
            <strong>KeyboardArrowDownOutlinedIcon.</strong> fleet nav items, fleet filter
            selector, user dropdown menu
          </p>
        </div>
        <div>
          <KeyboardArrowRightIcon />
          <p>
            <strong>KeyboardArrowRightIcon.</strong> customisation profile, nav menu,
            configuration history, sfe search, group page expand group
          </p>
        </div>
        <div>
          <FirstPageIcon />
          <p>
            <strong>FirstPageIcon.</strong> table pagination
          </p>
        </div>
        <div>
          <LastPageIcon />
          <p>
            <strong>LastPageIcon.</strong> table pagination
          </p>
        </div>
        <div>
          <DownloadIcon />
          <p>
            <strong>DownloadIcon.</strong> job download, client installer popup, download
            links on typography (on hover??)
          </p>
        </div>
        <div>
          <EFDownloadIcon />
          <p>
            <strong>EFDownloadIcon.</strong> Download client installer
          </p>
        </div>
        <div>
          <EFReplyIcon />
          <p>
            <strong>EFReplyIcon.</strong> Navigate backwards breadcrumb
          </p>
        </div>
        <div>
          <ArrowDropDownIcon />
          <p>
            <strong>ArrowDropDownIcon.</strong> chart filter dropdowns, sfe manage select
            key type expansion
          </p>
        </div>
      </div>
      <h3>Form elements</h3>
      <div className='testGrid'>
        <div>
          <EFCanlendar />
          <p>
            <strong>EFCanlendar.</strong> form input icon datepicker
          </p>
        </div>
        <div>
          <EFCheckBlankIcon />
          <p>
            <strong>EFCheckBlankIcon.</strong> checkbox input
          </p>
        </div>
        <div>
          <EFCopyIcon />
          <p>
            <strong>EFCopyIcon.</strong> Inputs where value copied to clipboard
          </p>
        </div>
        <div>
          <Visibility />
          <p>
            <strong>Visibility.</strong> password field
          </p>
        </div>
        <div>
          <VisibilityOff />
          <p>
            <strong>VisibilityOff.</strong> password field
          </p>
        </div>
        <div>
          <SearchIcon />
          <p>
            <strong>SearchIcon.</strong> Search input, table search
          </p>
        </div>
        <div>
          <EFDragIndicatorIcon />
          <p>
            <strong>EFDragIndicatorIcon.</strong> Draggable field - table settings and
            field mapping
          </p>
        </div>
        <div>
          <EFFilterIcon />
          <p>
            <strong>EFFilterIcon.</strong> Table filter button
          </p>
        </div>
        <div>
          <MoreIcon />
          <p>
            <strong>MoreIcon.</strong> Context menu icon - unused? enhanced toolbar for
            fleet permissions?
          </p>
        </div>
        <div>
          <MoreVertIcon />
          <p>
            <strong>MoreVertIcon.</strong> edit dashboard - unused
          </p>
        </div>
        <div>
          <FullscreenIcon />
          <p>
            <strong>FullscreenIcon.</strong> Charts, expand to 'full screen'
          </p>
        </div>
        <div>
          <FullscreenExitIcon />
          <p>
            <strong>FullscreenExitIcon.</strong> Charts, exit 'full screen'
          </p>
        </div>
        <div>
          <EFTableSettingIcon />
          <p>
            <strong>EFTableSettingIcon.</strong> table settings icon
          </p>
        </div>
        <div>
          <EFUploadImage />
          <p>
            <strong>EFUploadImage.</strong> upload image on profile page
          </p>
        </div>
        <div>
          <CloseIcon />
          <p>
            <strong>CloseIcon.</strong> Popup close, file import close
          </p>
        </div>
        <div>
          <EFAddIcon />
          <p>
            <strong>EFAddIcon.</strong> Unused?
          </p>
        </div>
        <div>
          <EFDeleteIcon />
          <p>
            <strong>EFDeleteIcon.</strong> Delete device or group
          </p>
        </div>
        <div>
          <EFPencilIcon />
          <p>
            <strong>EFPencilIcon.</strong> Group card - unused (commented out)
          </p>
        </div>
      </div>

      <h3>'State' / Status / Result</h3>
      <div className='testGrid'>
        <div>
          <ErrorIcon />
          <p>
            <strong>ErrorIcon.</strong> dashboard alerts summary, otap state, licence key,
            configuration/generation error
          </p>
        </div>
        <div>
          <CheckCircleIcon />
          <p>
            <strong>CheckCircleIcon.</strong> OTAP state 'Uptodate' or 'Available for OTAP', licence key
          </p>
        </div>
        <div>
          <DoDisturbIcon />
          <p>
            <strong>DoDisturbIcon.</strong> OTAP state 'No Site'
          </p>
        </div>
        <div>
          <SwapHorizontalCircleIcon />
          <p>
            <strong>SwapHorizontalCircleIcon.</strong> OTAP state 'Initiated'
          </p>
        </div>
        <div>
          <ContrastIcon />
          <p>
            <strong>ContrastIcon.</strong> OTAP state 'Initiated'
          </p>
        </div>
        <div>
          <DoNotDisturbOnOutlinedIcon />
          <p>
            <strong>DoNotDisturbOnOutlinedIcon.</strong> OTAP state 'Unknown'
          </p>
        </div>
        <div>
          <CancelIcon />
          <p>
            <strong>CancelIcon.</strong> cancel otap, asset licence disabled
          </p>
        </div>
        <div>
          <PanoramaFishEyeIcon />
          <p>
            <strong>PanoramaFishEyeIcon.</strong> 'blank' change password checklist
          </p>
        </div>
        <div>
          <CircleIcon />
          <p>
            <strong>CircleIcon.</strong>chart tooltip
          </p>
        </div>
        <div>
          <ErrorOutlineIcon />
          <p>
            <strong>ErrorOutlineIcon.</strong> Toast error, validate password failed
          </p>
        </div>
        <div>
          <CheckCircleOutlineIcon />
          <p>
            <strong>CheckCircleOutlineIcon.</strong> device state mandatory/latest
            version, toast success, password validate pass
          </p>
        </div>
        <div>
          <EFDuplicateIcon />
          <p>
            <strong>EFDuplicateIcon.</strong> Group and devices tables - duplicate values
            detected
          </p>
        </div>
        <div>
          <EFEmptyIcon />
          <p>
            <strong>EFEmptyIcon.</strong> Group and devices tables - empty values detected
          </p>
        </div>
        <div>
          <EFCheckMark />
          <p>
            <strong>EFCheckMark.</strong> Mandatory configuration display
          </p>
        </div>
        <div>
          <EFPendingIcon />
          <p>
            <strong>EFPendingIcon.</strong> Pending changes to group configuration
          </p>
        </div>
        <div>
          <img src='/images/device-warning-duplicate-light.svg' alt='device-warning-duplicate-light' />
          <p>
            <strong>device-warning-duplicate-light.</strong> unused
          </p>
        </div>
        <div>
          <img src='/images/device-warning-empty-light.svg' alt='device-warning-empty-light'/>
          <p>
            <strong>device-warning-empty-light.</strong> unused
          </p>
        </div>
        <div>
          <img src='/images/device-warning-modified-light.svg' alt='device-warning-modified-light' />
          <p>
            <strong>device-warning-modified-light.</strong> unused
          </p>
        </div>
      </div>

      <div className='testGrid'>
        <div>
          <p>
            <strong>radio types<br/>AssetMappingIcon</strong>
          </p>
          <div>
            <AssetMappingIcon deviceFormationId={1} />
            &nbsp;
            <AssetMappingIcon deviceFormationId={401} />
            &nbsp;
            <AssetMappingIcon deviceFormationId={303} />
            &nbsp;
            <AssetMappingIcon deviceFormationId={201} />
            &nbsp;
            <AssetMappingIcon deviceFormationId={107} />
            &nbsp;
            <AssetMappingIcon deviceFormationId={700} />
          </div>
        </div>
        <div>
          <ActivityIcon
            width={icoSize}
            height={icoSize}
          />
          <p>
            <strong>ActivityIcon.</strong> Navbar Icon
          </p>
        </div>
        <div>
          <AdminIcon
            width={icoSize}
            height={icoSize}
          />
          <p>
            <strong>AdminIcon.</strong> Navbar Icon
          </p>
        </div>
        <div>
          <EFAppearanceIcon />
          <p>
            <strong>EFAppearanceIcon.</strong> User menu
          </p>
        </div>
        <div>
          <AssetsIcon />
          <p>
            <strong>AssetsIcon.</strong> Navbar Icon
          </p>
        </div>
        <div>
          <BellIcon
            width={icoSize}
            height={icoSize}
          />
          <p>
            <strong>BellIcon.</strong> alerts page link
          </p>
        </div>
        <div>
          <ChartIcon
            width={icoSize}
            height={icoSize}
          />
          <p>
            <strong>ChartIcon.</strong> Navbar icon
          </p>
        </div>
        <div>
          <ConfigIcon />
          <p>
            <strong>ConfigIcon.</strong> Navbar icon
          </p>
        </div>
        <div>
          <DeviceIcon />
          <p>
            <strong>DeviceIcon.</strong> Navbar icon
          </p>
        </div>
        <div>
          <GroupIcon
            width={icoSize}
            height={icoSize}
          />
          <p>
            <strong>GroupIcon.</strong> nav bar icon
          </p>
        </div>
        <div>
          <HelpIcon
            width={icoSize}
            height={icoSize}
          />
          <p>
            <strong>HelpIcon.</strong> nav bar help icon (top)
          </p>
        </div>
        <div>
          <HomeIcon />
          <p>
            <strong>HomeIcon.</strong> Breadcrumb home icon
          </p>
        </div>
        <div>
          <EFLogoutIcon />
          <p>
            <strong>EFLogoutIcon.</strong> Log out button user dropdown
          </p>
        </div>
        <div>
          <ReportIcon
            width={icoSize}
            height={icoSize}
          />
          <p>
            <strong>ReportIcon.</strong> Unused - reports link nav menu
          </p>
        </div>
        <div>
          <SettingIcon />
          <p>
            <strong>SettingIcon.</strong> user profile settings
          </p>
        </div>
        <div>
          <SunIcon
            width={icoSize}
            height={icoSize}
          />{' '}
          <p>
            <strong>SunIcon.</strong> unused - used to be on light/dark mode selector
          </p>
        </div>

        <div>
          <LanguageIcon />
          <p>
            <strong>LanguageIcon.</strong> Login page language
          </p>
        </div>
      </div>
    </div>
  )
}
